import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Breadcrumb, BreadcrumbRouteParam} from './breadcrumb.model';

@Injectable({
  providedIn: 'root',
})
export class NgDynamicBreadcrumbService {
  public breadcrumbLabels: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public newBreadcrumb: BehaviorSubject<Breadcrumb[]> = new BehaviorSubject<Breadcrumb[]>([]);
  public notifyRouter: BehaviorSubject<BreadcrumbRouteParam | null> = new BehaviorSubject<BreadcrumbRouteParam | null>(null);
  constructor() {}

  updateBreadcrumbLabels(labels: any) {
    this.breadcrumbLabels.next(labels);
  }

  updateBreadcrumb(newBreadcrumb: Breadcrumb[]) {
    this.newBreadcrumb.next(newBreadcrumb);
  }
  notifyRouterFun(value: BreadcrumbRouteParam): void {
    this.notifyRouter.next(value);
  }
}
